import { formatNum } from '@app/utils/math';
import { useState } from 'react';

type ProgressCardType = 'monthly' | 'quarterly' | 'yearly';

type PlanResult = {
  plan?: number | null;
};

type Props = {
  type: ProgressCardType;
  data: PlanResult;
  canEditPlans: boolean;
  monthlyUpdate: any;
  quarterlyUpdate: any;
  yearlyUpdate: any;
};

export const useManagePlanResults = ({
  type,
  data,
  canEditPlans,
  monthlyUpdate,
  quarterlyUpdate,
  yearlyUpdate,
}: Props) => {
  const [isEditPopup, setEditPopup] = useState<boolean>(false);
  const [planValue, setPlanValue] = useState<string>('');

  const openPopup = () => {
    const currentPlan = data.plan;
    setPlanValue(currentPlan != null ? formatNum(currentPlan) : '');
    setEditPopup(true);
  };

  const closePopup = () => setEditPopup(false);

  const onUpdatePlan = async (newPlan: string) => {
    if (!canEditPlans) return;

    const normalizedPlan = newPlan.replace(/\s/g, '').replace(',', '.');

    if (type === 'monthly') {
      await monthlyUpdate.fetch({ plan: normalizedPlan });
    } else if (type === 'quarterly') {
      await quarterlyUpdate.fetch({ plan: normalizedPlan });
    } else {
      await yearlyUpdate.fetch({ plan: normalizedPlan });
    }

    setEditPopup(false);
  };

  return { isEditPopup, openPopup, closePopup, planValue, onUpdatePlan };
};
